import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/payments';

import PaymentHistory from './payment';
import {resetStore} from "../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.payment,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(PaymentHistory);
